export default __webpack_public_path__ + "static/ThinkstockPhotos-528719852_article-ee3f73f754955b38472e07c6bff7bf61.jpg";